<template>
	<div style="width: 100%;" class="d-flex">
		<div style="width: 17%;margin-right: 1%;height: 700px;background: #fff;">
			<div class="d-flex">
				<div class="acs" style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;" @click="alldata">全选</div>
				<div class="acs" style="border-top-right-radius: 5px;border-bottom-right-radius: 5px;" @click="gosx">筛选</div>
			</div>
			<div class="search-option">
				<el-tree :data="data" show-checkbox default-expand-all :props="defaultProps" @check="currentChecked"></el-tree>
			</div>
		</div>
		<div style="width: 82%;background: #ffffff;">
			<div ref="myCharta" style="width: 100%; height: 90%;"></div>
		</div>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import moment from 'moment';
import * as vueEcharts from "echarts";
let echarts = require('echarts');
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			preUrl: 'cwmx', // api

			tablist:[],
			tabIndex: 0,
			tabbars: [
				{ name: '全部', key: 'all' },
				{ name: '收入记账', key: 'srjz' },
				{ name: '支出记账', key: 'zcjz' },
				{ name: '产品记账', key: 'cpjz' },
				{ name: '我创建的', key: 'min_stock' },
				{ name: '我关注的', key: 'min_stock' }
			],
			form: {},
			tableData: [],
			maxHeight:0,
			data: [{
					id: 1,
					label: '收入记账',
					children: [{
						id: 4,
						label: '收款订单',
			 		},{
						id: 5,
						label: '预收款订单',
			 		},{
						id: 6,
						label: '收回欠款',
			 		},{
						id: 7,
						label: '退还收入',
			 		},{
						id: 8,
						label: '借入/收押金等',
			 		},{
						id: 9,
						label: '转账取存',
			 		}]
				},{
					id: 2,
					label: '支出记账',
					children: [{
						id: 10,
						label: '付款订单',
			 		},{
						id: 11,
						label: '预付款订单',
			 		},{
						id: 12,
						label: '偿还欠款',
			 		},{
						id: 13,
						label: '退还支出',
			 		},{
						id: 14,
						label: '借出/交押金等',
			 		}]
				},{
					id: 3,
					label: '产品记账',
					children: [{
						id: 15,
						label: '采购出库收入',
			 		},{
						id: 16,
						label: '采购入库支出',
			 		},{
						id: 17,
						label: '库存处理收入',
			 		},{
						id: 18,
						label: '库存处理支出',
			 		},{
						id: 19,
						label: '产品销售收入',
			 		},{
						id: 20,
						label: '产品退货支出',
			 		}]
			}],
			moment,
			day:[],
			cheshia:[],
			cheshib:[],
			cheshic:[],
			defaultProps: {
				children: 'children',
				label: 'label'
			}
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	// 计算属性
	computed: {
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		// 画统计图
		this.drawLine();
		this.changeRecent();
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 90; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		changeRecent(value) {
			for(let i = 0;i<30;i++){
				this.day.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
				this.cheshia.push(Math.floor(Math.random()*(10000-500))+500)
				this.cheshib.push(Math.floor(Math.random()*(10000-500))+500)
				this.cheshic.push(Math.floor(Math.random()*(10000-500))+500)
			}
			console.log(this.day)
		},
		alldata(){
			this.tabIndex = 0
			this.getList()
		},
		getList() {
			if(this.preUrl == '') return
			this.showLoading()
			let url = this.getListUrl()
			this.axios.get(url, { // 商品规格 api
				token: true
			}).then(res => {
				let data = res.data.data
				this.page.total = data.totalCount // 获取分页信息
				this.getListResult(data) // 获取到的数据储存到getListResult(data)，方便外面调用修改
				this.hideLoading()
			}).catch(err => {
				this.hideLoading()
			})
		},
		gosx(e){
			// this.tabIndex = e
			// this.getList()
			// console.log(this.tablist);
		},
		currentChecked (nodeObj, SelectedObj) {
			let ids = SelectedObj.checkedNodes
			if(ids.length>0){
				if(ids[0].id == 1){
					this.tabIndex = 1
					this.getList()
				}else if(ids[0].id == 2){
					this.tabIndex = 2
					this.getList()
				}else if(ids[0].id == 3){
					this.tabIndex = 3
					this.getList()
				}
			}
		      console.log(SelectedObj.checkedNodes)  // 这是选中的节点数组  
 
		},

		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list;
		},
		drawLine() {
				let myCharta = echarts.init(this.$refs.myCharta);
				var that = this;
				setTimeout(function() {
					// 配置参数
					myCharta.setOption({
						  tooltip: {
						    trigger: 'axis'
						  },
						  grid: {
						    left: '3%',
						    right: '4%',
						    bottom: '3%',
						    containLabel: true
						  },
						  toolbox: {
						    feature: {
						      saveAsImage: {}
						    }
						  },
						  xAxis: {
						    type: 'category',
						    boundaryGap: false,
						    data: that.day
						  },
						  yAxis: {
						    type: 'value'
						  },
						  series: [
						    {
						      name: '今日收入',
						      type: 'line',
						      stack: 'Total',
						      data: that.cheshia
						    },
						    {
						      name: '今日支出',
						      type: 'line',
						      stack: 'Total',
						      data: that.cheshib
						    },
						    {
						      name: '利润',
						      type: 'line',
						      stack: 'Total',
						      data: that.cheshic
						    },
						  ]
					})
				}, 1000);
			},
		},
	}

</script>

<style scoped>
.acs {
	background: #00c240;
	color: #fff;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 30px;
}
.acs:hover {
	background: #00f150;
}
.search-option >>>.el-tree-node__label {
    font-size: 12px;
}
.el-form-item{
	margin-bottom:10px
}
</style>
